import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProxmoxService } from '../../../services/proxmox.service';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
  isLoggedIn: boolean = false;
  nodes: any[] = [];
  vms: any[] = [];

  constructor(
    private proxmoxService: ProxmoxService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Check if already logged in
    this.isLoggedIn = this.proxmoxService.isAuthenticated();
    
    // If not logged in, redirect to login page
    if (!this.isLoggedIn) {
      this.router.navigate(['/log-in']);
      return;
    }
    
    // Redirect to the new Proxmox API explorer
    this.router.navigate(['/proxmox-api-explorer']);
  }

  /**
   * Handle logout
   */
  onLogout(): void {
    this.proxmoxService.logout();
    this.isLoggedIn = false;
    this.nodes = [];
    this.vms = [];
    // Redirect to login page after logout
    this.router.navigate(['/log-in']);
  }

  /**
   * Load dashboard data after successful login
   */
  loadDashboardData(): void {
    // Load nodes
    this.proxmoxService.getNodes().subscribe({
      next: (response) => {
        this.nodes = response.data || [];
      },
      error: (error) => {
        console.error('Error loading nodes:', error);
      }
    });

    // Load VMs
    this.proxmoxService.getVMs().subscribe({
      next: (response) => {
        this.vms = response.data || [];
      },
      error: (error) => {
        console.error('Error loading VMs:', error);
      }
    });
  }

  /**
   * Format bytes to human readable format
   */
  formatBytes(bytes: number, decimals = 2): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}